import { rpc } from "#rpc";
import { useLocale } from "@/i18n/client";
import { useQuery } from "@tanstack/react-query";

export const useLoyaltyContent = () => {
	const locale = useLocale();
	return useQuery({
		queryKey: ["loyalty-content"],
		queryFn: async () => {
			return rpc.loyalty.loyaltyContent(locale);
		},
		staleTime: Number.POSITIVE_INFINITY,
	});
};
